<div class="ec-representatives-container">
    <div class="mt-12">
        <button app-ghost-button (click)="onClickGotoDashboard()" class="pearl-white">
            <app-icon name="fal-arrow-left"></app-icon>
            {{ 'Back to dashboard'|i18n }}
        </button>
    </div>
    <div class="ec-members-container mt-16">
        <div class="grey-border">
            <div fxLayout="row" fxLayoutAlign="space-between center" class="mb-32 mt-16">
                <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="36px">
                    <div app-input-container class="member-search-container"
                         *appVar="searchTextFilter as textFilterCtrl">
                        <input app-input [formControl]="textFilterCtrl"
                               class="member-search"
                               [spellcheck]="false"
                               [placeholder]="'Search document by type'|i18n">
                        <app-icon *ngIf="!!textFilterCtrl.value" name="fal-times" class="right-symbol clear"
                                  (click)="textFilterCtrl.setValue('')">
                        </app-icon>
                        <svg *ngIf="!textFilterCtrl.value" xmlns="http://www.w3.org/2000/svg"
                             viewBox="0 0 512 512"
                             class="right-symbol mag-glass">
                            <!--! Font Awesome Pro 6.2.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. -->
                            <path d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352c79.5 0 144-64.5 144-144s-64.5-144-144-144S64 128.5 64 208s64.5 144 144 144z"/>
                        </svg>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="start center"
                         fxLayoutGap="8px">
                        <div fxFlex app-input-container
                             *appVar="searchTagFilter as tagFilterCtrl">
                            <mat-select app-small-select
                                        class="status-filter"
                                        [formControl]="tagFilterCtrl">
                                <mat-option *ngFor="let tag of TAGS" [value]="tag"
                                            class="mat-primary">
                                    {{ tag.name|i18n }}
                                </mat-option>
                            </mat-select>
                        </div>
                    </div>
                </div>
                <div>
                    <button app-primary-button (click)="onClickNewDocument()"
                            [disabled]="!canCreateDoc">
                        <app-icon name="fal-plus-circle"></app-icon>
                        {{ 'Add document'|i18n }}
                    </button>
                </div>
            </div>
            <div class="white-rounded-background">
                <ng-container *appVar="documents|async as documents">
                    <ng-container *ngIf="documents; else loadingDocuments">
                        <ng-container *ngIf="documents.documents.length">
                            <table mat-table app-table [dataSource]="documents.documents"
                                   multiTemplateDataRows class="member-table">
                                <ng-container matColumnDef="type">
                                    <th mat-header-cell *matHeaderCellDef>
                                        <div fxLayout="row" fxLayoutAlign="start">
                                            {{ 'Typology'|i18n }}
                                        </div>
                                    </th>
                                    <td mat-cell
                                        *matCellDef="let row">
                                        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="12px">
                                            <app-icon name="fal-file" class="txt-d-18-7" fxFlex="5"></app-icon>
                                            <span>{{ row.document_type || '-' }}</span>
                                        </div>
                                    </td>
                                </ng-container>
                                <ng-container matColumnDef="filename">
                                    <th mat-header-cell *matHeaderCellDef>
                                        <div fxLayout="row" fxLayoutAlign="start center">
                                            {{ 'File name'|i18n }}
                                        </div>
                                    </th>
                                    <td mat-cell
                                        *matCellDef="let row">{{ row.filename || '-' }}
                                    </td>
                                </ng-container>
                                <ng-container matColumnDef="uploadedOn">
                                    <th mat-header-cell *matHeaderCellDef>
                                        <div fxLayout="row" fxLayoutAlign="center center">
                                            <span>{{ 'Uploaded on'|i18n }}:</span>
                                            <button *ngIf="getSortDirection(SortCriterion.UPLOADED_AT) === SortDirection.ASC"
                                                    app-icon-button class="sort-button ml-16"
                                                    (click)="onClickSortBy(SortCriterion.UPLOADED_AT, SortDirection.DESC)">
                                                <app-icon name="fal-sort-amount-up"></app-icon>
                                            </button>
                                            <button *ngIf="getSortDirection(SortCriterion.UPLOADED_AT) === SortDirection.DESC"
                                                    app-icon-button class="sort-button ml-16"
                                                    (click)="onClickSortBy(SortCriterion.UPLOADED_AT, SortDirection.ASC)">
                                                <app-icon name="fal-sort-amount-down"></app-icon>
                                            </button>
                                        </div>
                                    </th>
                                    <td mat-cell *matCellDef="let row">
                                        <div fxLayout="row" fxLayoutAlign="center">
                                            <div>
                                                {{ isDefined(row.upload_date) ? (row.upload_date|i18nDate) : '--/--/--' }}
                                            </div>
                                        </div>
                                    </td>
                                </ng-container>
                                <ng-container matColumnDef="tag">
                                    <th mat-header-cell *matHeaderCellDef>
                                        <div fxLayout="row" fxLayoutAlign="center">
                                            {{ 'Tag'|i18n }}
                                        </div>
                                    </th>
                                    <td mat-cell *matCellDef="let row" class="tag">
                                        <div fxLayout="row" fxLayoutAlign="center">
                                            <div *appVar="getDocumentTag(row) as tag"
                                                 class="rep-tag">
                                                <div class="tag-box" fxLayoutAlign="start center"
                                                     [ngClass]="'tag-' + tag">
                                                    <app-icon fxFlex="30" fxLayoutAlign="center center"
                                                              name="fal-check-circle"
                                                              class="tag-icon"
                                                              [ngClass]="'tag-' + tag">
                                                    </app-icon>
                                                    <div fxLayoutAlign="start center">
                                                        <div>{{ getTagName(tag)|i18n }}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                </ng-container>
                                <ng-container matColumnDef="actions">
                                    <th mat-header-cell *matHeaderCellDef>
                                    </th>
                                    <td mat-cell *matCellDef="let row" class="actions">
                                        <div fxLayout="row" fxLayoutAlign="end" fxLayoutGap="24px">
                                            <button app-icon-button
                                                    [disabled]="!canEditDoc"
                                                    [title]="'Edit document'|i18n"
                                                    (click)="onClickEditDocument(row)">
                                                <app-icon name="fal-pencil-alt"></app-icon>
                                            </button>
                                            <button app-icon-button class="app-button-alert"
                                                    [disabled]="!canDeleteDoc"
                                                    [title]="'Delete document'|i18n"
                                                    (click)="onClickDeleteDocument(row)">
                                                <app-icon name="fal-trash-alt" class="no-margin"></app-icon>
                                            </button>
                                            <button app-icon-button
                                                    [disabled]="!canDownloadDoc"
                                                    [title]="'Download document'|i18n"
                                                    (click)="onClickDownloadCommunityDocument(row)">
                                                <app-icon name="fal-download"></app-icon>
                                            </button>
                                        </div>
                                    </td>
                                </ng-container>
                                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                <tr mat-row *matRowDef="let row; columns: displayedColumns;"
                                    class="app-row app-border-upper-row"></tr>
                            </table>
                        </ng-container>
                        <div *ngIf="!documents.documents.length" fxLayout="row" fxLayoutAlign="center" class="mb-12">
                            {{ 'No documents found'|i18n }}
                        </div>
                    </ng-container>
                    <mat-paginator #paginator app-paginator class="member-paginator"
                                   [ngClass]="{'collapsed': !documents || documents.total === 0 }"
                                   [length]="documents?.total" [pageSize]="PAGE_SIZE"
                                   [pageSizeOptions]="PAGE_SIZES">
                    </mat-paginator>
                </ng-container>
            </div>
        </div>
    </div>
</div>

<ng-template #newDocument>
    <div class="new-document-container">
        <form [formGroup]="uploadDocForm">
            <div fxLayout="column">
                <div fxLayoutAlign="end">
                    <button mat-icon-button [mat-dialog-close]="false">
                        <app-icon name="fal-times"></app-icon>
                    </button>
                </div>
                <div fxLayout="row" fxLayoutAlign="center center" class="main-title mt-24">
                    {{ 'Add community document'|i18n }}
                </div>
                <div fxLayout="column" class="form mt-32">
                    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="24px">
                        <div fxLayout="row" fxLayoutAlign="end" fxFlex="30"
                             class="t-right">{{ ('Typology'|i18n) + ':*' }}
                        </div>
                        <div fxFlex>
                            <mat-select app-small-select formControlName="documentType"
                                        placeholder="{{'Denote typology'|i18n}}" fxFlex>
                                <mat-option *ngFor="let documentType of documentTypes" [value]="documentType">
                                    <div>{{ documentType|i18n }}</div>
                                </mat-option>
                            </mat-select>
                        </div>
                        <div fxFlex="20"></div>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="24px">
                        <div fxFlex="30"></div>
                        <div *ngIf="!documentTypeIsEmpty && duplicatePrivacyPolicy && uploadDocForm.controls.documentType.value !== EC_DOCUMENT_TYPE_OTHER"
                             class="invalid-doc" app-error>
                            {{ 'Document type already uploaded'|i18n }}
                        </div>
                    </div>
                    <div *ngIf="uploadDocForm.controls.documentType.value === EC_DOCUMENT_TYPE_OTHER" fxLayout="column">
                        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="24px" class="mt-10">
                            <div fxFlex="30"></div>
                            <div fxFlex app-input-container>
                                <input #input app-input
                                       formControlName="customDocumentType"
                                       [placeholder]="'Denote typology'|i18n"
                                       [maxLength]="NAME_MAX_CHARS">
                            </div>
                            <div fxFlex="20"></div>
                        </div>
                        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="24px">
                            <div fxFlex="30"></div>
                            <div fxFlex="50" class="mt-4" fxLayout="row" fxLayoutAlign="space-between center">
                                <mat-hint class="txt-s-12-4">
                                    {{ 'Max {0} characters'|i18n:NAME_MAX_CHARS }}
                                </mat-hint>
                                <mat-hint class="txt-s-12-4">
                                    {{ input.value.length }}
                                    / {{ NAME_MAX_CHARS }} {{ 'characters'|i18n }}
                                </mat-hint>
                            </div>
                            <div fxFlex="20"></div>
                        </div>
                        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="24px">
                            <div fxFlex="30"></div>
                            <div fxFlex="50" fxLayout="row" fxLayoutAlign="space-between center">
                                <div *ngIf="documentTypeIsEmpty"
                                     class="invalid-doc" app-error>
                                    {{ 'Invalid document type'|i18n }}
                                </div>
                                <div *ngIf="invalidDocumentTypeName"
                                     class="invalid-doc" app-error>
                                    {{ 'Only alphanumeric characters are allowed'|i18n }}
                                </div>
                                <div *ngIf="!documentTypeIsEmpty && duplicatePrivacyPolicy"
                                     class="invalid-doc" app-error>
                                    {{ 'Document type already uploaded'|i18n }}
                                </div>
                            </div>
                            <div fxFlex="20"></div>
                        </div>
                    </div>
                    <div class="mt-24" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px">
                        <div fxLayout="row" fxLayoutAlign="end"
                             fxFlex="30">{{ ('Upload document'|i18n) + ':*' }}
                        </div>
                        <div fxFlex="35" fxLayout="row"
                             fxLayoutAlign="start center" fxLayoutGap="20px">
                            <input #fileSelect type="file" style="display: none"
                                   [accept]="ACCEPTED_MIME_TYPES"
                                   (change)="uploadDocument($event)">
                            <button app-small-primary-button (click)="fileSelect.click()">
                                <app-icon [name]="currentDocument ? 'fal-sync' : 'fal-search'"></app-icon>
                                {{ (currentDocument ? 'Change file' : 'Upload file')|i18n }}
                            </button>
                            <div *ngIf="currentDocument">{{ currentDocument.filename }}</div>
                            <div *ngIf="!currentDocument && uploadDocForm.controls.filename.dirty" app-error>
                                {{ 'No file uploaded'|i18n }}
                            </div>
                            <div *ngIf="!currentDocument && !uploadDocForm.controls.filename.dirty" class="txt-s-14-4">
                                {{ 'No document'|i18n }}
                            </div>
                        </div>
                        <div fxFlex="35" fxLayoutAlign="start center">
                            <div fxFlex="60" fxLayoutAlign="end center">
                                <button *ngIf="currentDocument" app-icon-button class="app-button-alert"
                                        [title]="'Remove document'|i18n"
                                        (click)="removeDocument()">
                                    <app-icon name="fal-trash-alt"></app-icon>
                                </button>
                            </div>
                            <div fxFlex="40"></div>
                        </div>
                    </div>
                    <div class="mt-8" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px">
                        <div fxFlex="30">
                        </div>
                        <div fxFlex>
                            <span class="txt-s-14-4">{{ '(Max {0} MB. Accepts only {1}.)'|i18n:MAX_FILE_MB:ACCEPTED_MIME_TYPES }}</span>
                        </div>
                        <div fxFlex="10"></div>
                    </div>
                    <div *ngIf="currentDocument" class="mt-24">
                        <mat-divider></mat-divider>
                        <div class="mt-32">
                            <div fxLayout="row" fxLayoutAlign="start center">
                                <div fxFlex="30"></div>
                                <mat-checkbox app-checkbox formControlName="visibleInApp" class="pl-16"
                                [disabled]="uploadDocForm.controls.documentType.value !== EC_DOCUMENT_TYPE_OTHER">
                                    <span class="txt-p-16-4">{{ 'Visible in app'|i18n }}</span>
                                </mat-checkbox>
                                <div fxFlex="20"></div>
                            </div>
                            <div fxLayout="row" fxLayoutAlign="start center">
                                <div fxFlex="30"></div>
                                <mat-checkbox app-checkbox formControlName="optional" class="pl-16">
                                    <span class="txt-p-16-4">{{ 'Optional'|i18n }}</span>
                                </mat-checkbox>
                                <div fxFlex="20"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="48px" class="mt-48">
                    <button app-ghost-button fxLayoutAlign="space-around center" fxLayoutGap="16px"
                            [mat-dialog-close]="false"
                            class="min-width-130">
                        <span>{{ 'Cancel'|i18n }}</span>
                    </button>
                    <button app-primary-button fxLayoutAlign="space-around center" fxLayoutGap="16px"
                            [disabled]="uploadDocForm.invalid" [mat-dialog-close]="true"
                            class="min-width-130">
                        <span>{{ 'Save'|i18n }}</span>
                    </button>
                </div>
            </div>
        </form>
    </div>
</ng-template>

<ng-template #editDocument>
    <div class="new-document-container">
        <form [formGroup]="updateDocForm">
            <div fxLayout="column">
                <div fxLayoutAlign="end">
                    <button mat-icon-button [mat-dialog-close]="false">
                        <app-icon name="fal-times"></app-icon>
                    </button>
                </div>
                <div fxLayout="row" fxLayoutAlign="center center" class="main-title mt-24">
                    {{ 'Edit details'|i18n }}
                </div>
                <div fxLayout="column" class="form mt-32">
                    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="24px">
                        <div fxLayout="row" fxLayoutAlign="end" fxFlex="30"
                             class="t-right">{{ ('Typology'|i18n) + ':*' }}
                        </div>
                        <div fxFlex>
                            <mat-select app-small-select formControlName="documentType"
                                        placeholder="{{'Denote typology'|i18n}}" fxFlex>
                                <mat-option *ngFor="let documentType of documentTypes" [value]="documentType">
                                    {{ documentType|i18n }}
                                </mat-option>
                            </mat-select>
                        </div>
                        <div fxFlex="20"></div>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="24px">
                        <div fxFlex="30"></div>
                        <div *ngIf="!documentTypeIsEmpty && duplicatePrivacyPolicy && updateDocForm.controls.documentType.value !== EC_DOCUMENT_TYPE_OTHER"
                             class="invalid-doc" app-error>
                            {{ 'Document type already uploaded'|i18n }}
                        </div>
                    </div>
                    <div *ngIf="updateDocForm.controls.documentType.value === EC_DOCUMENT_TYPE_OTHER" fxLayout="column">
                        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="24px" class="mt-10">
                            <div fxFlex="30"></div>
                            <div fxFlex app-input-container>
                                <input #input app-input
                                       formControlName="customDocumentType"
                                       [placeholder]="'Denote typology'|i18n"
                                       [maxLength]="NAME_MAX_CHARS">
                            </div>
                            <div fxFlex="20"></div>
                        </div>
                        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="24px">
                            <div fxFlex="30"></div>
                            <div fxFlex="50" class="mt-4" fxLayout="row" fxLayoutAlign="space-between center">
                                <mat-hint class="txt-s-12-4">
                                    {{ 'Max {0} characters'|i18n:NAME_MAX_CHARS }}
                                </mat-hint>
                                <mat-hint class="txt-s-12-4">
                                    {{ input.value.length }}
                                    / {{ NAME_MAX_CHARS }} {{ 'characters'|i18n }}
                                </mat-hint>
                            </div>
                            <div fxFlex="20"></div>
                        </div>
                        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="24px">
                            <div fxFlex="30"></div>
                            <div fxFlex="50" fxLayout="row" fxLayoutAlign="space-between center">
                                <div *ngIf="documentTypeIsEmpty"
                                     class="invalid-doc" app-error>
                                    {{ 'Invalid document type'|i18n }}
                                </div>
                                <div *ngIf="invalidDocumentTypeName"
                                     class="invalid-doc" app-error>
                                    {{ 'Only alphanumeric characters are allowed'|i18n }}
                                </div>
                                <div *ngIf="!documentTypeIsEmpty && duplicatePrivacyPolicy"
                                     class="invalid-doc" app-error>
                                    {{ 'Document type already uploaded'|i18n }}
                                </div>
                            </div>
                            <div fxFlex="20"></div>
                        </div>
                    </div>
                    <div class="mt-24" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px">
                        <div fxLayout="row" fxLayoutAlign="end"
                             fxFlex="30">{{ ('Upload document'|i18n) + ':*' }}
                        </div>
                        <div fxFlex="35" fxLayout="row"
                             fxLayoutAlign="start center" fxLayoutGap="20px">
                            <input #fileSelect type="file" style="display: none"
                                   [accept]="ACCEPTED_MIME_TYPES"
                                   (change)="uploadEditedDocument($event)">
                            <button app-small-primary-button (click)="fileSelect.click()">
                                <app-icon [name]="updateDocument ? 'fal-sync' : 'fal-search'"></app-icon>
                                {{ (updateDocument ? 'Change file' : 'Upload file')|i18n }}
                            </button>
                            <div *ngIf="updateDocument">{{ updateDocument.filename }}</div>
                            <div *ngIf="!updateDocument && updateDocForm.controls.filename.dirty" app-error>
                                {{ 'No file uploaded'|i18n }}
                            </div>
                            <div *ngIf="!updateDocument && !updateDocForm.controls.filename.dirty" class="txt-s-14-4">
                                {{ 'No document'|i18n }}
                            </div>
                        </div>
                        <div fxFlex="35" fxLayoutAlign="start center">
                            <div fxFlex="60" fxLayoutAlign="end center">
                                <button *ngIf="updateDocument" app-icon-button class="app-button-alert"
                                        [title]="'Remove document'|i18n"
                                        (click)="removeEditedDocument()">
                                    <app-icon name="fal-trash-alt"></app-icon>
                                </button>
                            </div>
                            <div fxFlex="40"></div>
                        </div>
                    </div>
                    <div class="mt-8" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px">
                        <div fxFlex="30">
                        </div>
                        <div fxFlex>
                            <span class="txt-s-14-4">{{ '(Max {0} MB. Accepts only {1}.)'|i18n:MAX_FILE_MB:ACCEPTED_MIME_TYPES }}</span>
                        </div>
                        <div fxFlex="10"></div>
                    </div>
                    <div *ngIf="updateDocument" class="mt-24">
                        <mat-divider></mat-divider>
                        <div class="mt-32">
                            <div fxLayout="row" fxLayoutAlign="start center">
                                <div fxFlex="30"></div>
                                <mat-checkbox app-checkbox formControlName="visibleInApp" class="pl-16"
                                [disabled]="updateDocForm.controls.documentType.value !== EC_DOCUMENT_TYPE_OTHER">
                                    <span class="txt-p-16-4">{{ 'Visible in app'|i18n }}</span>
                                </mat-checkbox>
                                <div fxFlex="20"></div>
                            </div>
                            <div fxLayout="row" fxLayoutAlign="start center">
                                <div fxFlex="30"></div>
                                <mat-checkbox app-checkbox formControlName="optional" class="pl-16">
                                    <span class="txt-p-16-4">{{ 'Optional'|i18n }}</span>
                                </mat-checkbox>
                                <div fxFlex="20"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="48px" class="mt-48">
                    <button app-ghost-button fxLayoutAlign="space-around center" fxLayoutGap="16px"
                            [mat-dialog-close]="false"
                            class="min-width-130">
                        <span>{{ 'Cancel'|i18n }}</span>
                    </button>
                    <button app-primary-button fxLayoutAlign="space-around center" fxLayoutGap="16px"
                            [disabled]="updateDocForm.invalid" class="min-width-130"
                            [mat-dialog-close]="true">
                        <span>{{ 'Save'|i18n }}</span>
                    </button>
                </div>
            </div>
        </form>
    </div>
</ng-template>

<ng-template #deleteDocument let-data let-close="close">
    <div class="ml-42 mr-42">
        {{ 'Are you sure you want to delete document {0}?'|i18n:data.doc.document_type }}
    </div>
    <div fxLayout="row" fxLayoutAlign="space-between" app-dialog-actions>
        <button app-ghost-button (click)="close(false)">
            {{ 'No, cancel'|i18n }}
        </button>
        <button app-primary-button (click)="close(true)">
            {{ 'Yes, confirm'|i18n }}
        </button>
    </div>
</ng-template>

<ng-template #loadingDocuments>
    <div fxLayout="row" fxLayoutAlign="center center" class="mt-24 mb-16">
        <mat-spinner app-spinner diameter="20"></mat-spinner>
        <span class="pl-8">{{ 'Loading documents'|i18n }}...</span>
    </div>
</ng-template>

<ng-template #spinner let-data="data" let-close="close">
    <app-spinner [spinnerDataSubj]="data"
                 (closeSpinner)="close()">
    </app-spinner>
</ng-template>

<ng-template #notEnoughPerms>
    <div fxLayout="row" fxLayoutAlign="center" class="mt-16">
        {{ 'Insufficient permissions to see community\'s documents'|i18n }}
    </div>
</ng-template>

